import { Link } from "react-router-dom"
import cursor from "../assets/img/cursor.png"


const Fashion = () => {
    return (
    <div>
    <Link to="/"><img id='menu3' src={cursor} alt='menu' title="Home"></img></Link> 
    <Link to="/thesis"><p className='sub' id='menu2'>Thesis Collection</p></Link> 
    <Link to="/IH8FW"><p className='sub' id='menu1'>I Hate Fashion Week</p></Link> 
    </div>
    );
    
  };
  
  export default Fashion;